<template>
  <div id="app">
    <Navbar
      :is-sidebar-available="isSidebarAvailable"
      @toggle-sidebar="isSidebarOpen = !isSidebarOpen"
    />

    <router-view
      :is-sidebar-open="isSidebarOpen"
      class="content-wrap"
      @toggle-sidebar="setIsSidebarOpen"
      @set-is-sidebar-available="setIsSidebarAvailable"
    />

    <Footer class="footer" />
  </div>
</template>

<script>
import i18next from 'i18next';
import { mapState } from 'vuex';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import config from './config';

export default {
  components: {
    Navbar,
    Footer
  },
  metaInfo() {
    const locale = config.locales.find(
      ({ code }) => code === this.$skI18n.locale
    );

    return {
      titleTemplate: titleChunk => {
        const name = locale.code === 'en-GB' ? 'Meqyas' : 'مقياس';

        if (!titleChunk) {
          return name;
        }

        return i18next.dir() === 'rtl'
          ? `${name} | ${titleChunk}`
          : `${titleChunk} | ${name}`;
      },
      htmlAttrs: {
        lang: locale.code
      },
      bodyAttrs: {
        dir: locale.rtl ? 'rtl' : 'ltr'
      },
      meta: [
        // AWS env URLs are public - we need to prevent indexing
        // STG should never be indexed - Prod will be indexed once we go live with AWS
        {
          name: 'robots',
          content:
            process.env.VUE_APP_DO_NOT_INDEX === 'true' ? 'noindex' : 'all'
        }
      ]
    };
  },
  data: () => ({
    isSidebarOpen: false,
    isSidebarAvailable: false
  }),
  computed: {
    ...mapState(['app']),
    displaySubNav() {
      return this.$route.path.includes(this.subNav.primary.path);
    },
    subNav() {
      return this.app.find(slice => slice.slice_type === 'sub_navigation');
    }
  },
  watch: {
    app(newApp, oldApp) {
      // Refetch app when language changed
      if (oldApp && !newApp) {
        this.$store.dispatch('getApp');
      }
    }
  },
  serverPrefetch() {
    return this.$store.dispatch('getApp');
  },
  mounted() {
    if (!Object.keys(this.app).length) {
      this.$store.dispatch('getApp');
    }
  },
  methods: {
    setIsSidebarOpen(isSidebarOpen) {
      if (typeof isSidebarOpen === 'boolean') {
        this.isSidebarOpen = isSidebarOpen;
        return;
      }
      this.isSidebarOpen = !this.isSidebarOpen;
    },
    setIsSidebarAvailable(isSidebarAvailable) {
      this.isSidebarAvailable = isSidebarAvailable;
    }
  }
};
</script>

<style lang="scss" scoped>
@import './scss/base/variables';
@import './scss/helpers/mixins';

#app {
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 100vh;
}

.content-wrap {
  padding-top: $navbar-height;
  flex: 1 0 auto;
  padding-bottom: 94px;

  &.with-subnav {
    top: 120px;
  }
}
</style>
